import React from 'react'

import { OnSchedUtils } from '../../../../../../../utils'

const Weekday = ({ element, day, selectDay }) => {
  const [selected, setSelected] = React.useState(false);
  
  const clickDay = () => {
    setSelected(!selected);
    selectDay(day);
  }
  
  return (
    <div onClick={clickDay} className={`WeeklyAllocationsWeekday ${selected ? 'selected' : ''}`}>
      {OnSchedUtils.Internationalize(element, 'consumer_availability_weekday_' + day).slice(0,1)}
    </div>
  )
}

export default Weekday